<template>
  <header :style="{ backgroundImage: `url('${backgroundImage}')` }">
    <div class="item" :class="{ 'item--with-bottom': hasBottomSlot }">
      <div class="container">
        <div class="slide header-content">
          <div class="line"></div>
          <p>{{ anteTitle }}</p>
          <h1>{{ title }}</h1>
          <p>{{ postTitle }}</p>
        </div>
      </div>
      <div v-if="hasBottomSlot" class="header-bottom">
        <slot></slot>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  components: {},
  name: "HeaderBlue",
  props: {
    anteTitle: String,
    title: String,
    postTitle: String,
    backgroundImage: String,
  },
  computed: {
    hasBackgroundImage() {
      return this.backgroundImage !== undefined;
    },
    hasBottomSlot() {
      return !!this.$slots.default;
    },
  },
};
</script>

<style lang="scss" scoped>
header {
  --nav-offset: 74.4px;
  @media screen and (min-width: 992px) {
    --nav-offset: 84.4px;
  }
  @include background-responsive;
  & .item {
    width: 100%;
    height: 100%;
    min-height: 50vh;
    padding: calc(26px + var(--nav-offset)) 0 75px;
    display: flex;
    flex-direction: column;
    background: #002a549f;

    &.item--with-bottom {
      min-height: 64vh;
      padding-bottom: 32px;
    }
  }

  .header-bottom {
    width: 100%;
    margin-top: auto;
    padding-top: 24px;

    :deep(.row-icons) {
      margin: 0 auto;
      padding-bottom: 0;
    }
  }

  @media screen and (min-width: 992px) {
    .item {
      padding-top: calc(75px + var(--nav-offset));
    }

    .item.item--with-bottom {
      min-height: 80vh;
      padding-bottom: 44px;
    }

    .header-bottom {
      padding-top: 42px;
    }
  }
}
.header-content {
  position: relative;
  overflow: hidden;
  margin-top: 6px;
  padding: 24px 0px 30px 40px;
  @media screen and (min-width: 992px) {
    margin-top: 30px;
    padding: 56px;
  }
  & .line {
    display: inline-block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    border: 9px solid $color-secondary;
    -webkit-clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);
    clip-path: polygon(0 0, 60% 0, 36% 100%, 0 100%);
  }
  & p:first-of-type {
    font-family: "adam";
    color: #fff;
    font-size: 1.1em;
    @media screen and (min-width: 992px) {
      font-size: 1.6em;
    }
  }
  & h1 {
    font-family: "Spartan", "Arial Black", Arial, sans-serif;
    font-weight: 700;
    font-size: 1.5em;
    margin: 5px 0 20px;
    word-spacing: 3px;
    color: #fff;
    @media screen and (min-width: 992px) {
      font-size: 2.5em;
    }
  }
  & p:last-of-type {
    font-family: "adam";
    font-size: 1.1em;
    line-height: 1.4em;
    color: #fff;
    @media screen and (min-width: 992px) {
      font-size: 1.4em;
    }
  }
}
</style>
